// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { useRoles } from '../verRolesContext';
import { CircularProgress, Divider, List, ListItem, ListItemText, Typography } from '@mui/material';
import { useBody } from '../../Body/state/BodyContext';

export default function VerRolesArea({ area }) {
    const { getAreaRoles } = useRoles();
    const [areaRoles, setAreaRoles] = useState([]);
    const [loading, setLoading] = useState(false);
    const { setMessage } = useBody();

    const fetchAreasRoles = async () => {
        setLoading(true);
        try {
            const response = await getAreaRoles(area.id);
            setAreaRoles(response);
        } catch (error) {
            console.error("Error obteniendo los roles del área:", error);
            setMessage("Error obteniendo los roles del área");
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchAreasRoles();
    }, [area]);

    return (
        <>
            <Typography variant="h6" gutterBottom>
                Roles del Área: {area.name}
            </Typography>

            <Divider style={{ marginBlock: "20px" }} />

            {loading ? (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <CircularProgress color="secondary" />
                </div>
            ) : (
                <List>
                    {areaRoles.length > 0 ? (
                        areaRoles
                            .filter((role) => role.name !== "uma_protection")
                            .map((role) => (
                                <ListItem key={role.id}>
                                    <ListItemText
                                        primary={<strong>{role.name}</strong>}
                                        secondary={role.description}
                                    />
                                </ListItem>
                            ))
                    ) : (
                        <Typography variant="body2" color="textSecondary">
                            No tiene roles asignados.
                        </Typography>
                    )}
                </List>
            )}
        </>
    );
}
